import React from 'react'
import { FormattedMessage } from 'react-intl'

const showMoreButton = ({ expanded, toggleFunc }) => {
  return (
    <div className="align--right">
      <button
        type="button"
        className="button button--secondary button--small space--top-1"
        onClick={toggleFunc}
      >
        <FormattedMessage id={ expanded ? 'app.root.read-less' : 'app.root.read-more' }/>
      </button>
    </div>
  )
}

export default showMoreButton
